import { api } from "../ApiMapper/api";
import { ACCESS_TOKEN } from "../components/constants";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export const fetchSettings = async () => {
  try {
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (!token) {
      window.location.href = "/login";
      return null;
    }
    const response = await api.get("/api/settings");
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem(ACCESS_TOKEN);
      window.location.href = "/login";
      return null;
    }
    throw error;
  }
};

export const updateSettings = async (settings) => {
  try {
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (!token) {
      window.location.href = "/login";
      throw new Error("Please login to save settings");
    }
    const response = await api.post("/api/settings", settings);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem(ACCESS_TOKEN);
      window.location.href = "/login";
      throw new Error("Session expired. Please login again.");
    }
    throw error;
  }
};